<template>
  <div class="import-tool">
    <Modal v-model="visible" title="批量导入" :mask-closable="false" width="530" :footer-hide="true" class="my-modal top import-tool-modal2">
      <div class="box">
        <p class="text1">操作步骤：</p>
        <p class="text2">1、下载模板excel，根据模板字段批量填充数据。</p>
        <p class="text2">2、点击“上传excel”，将整理好的excel上传，请不要修改任何表头数据。</p>
        <p class="text2">3、如果存在异常数据，系统会直接导入正常数据，并自动下载异常数据excel，您可根据异常原因修改后重新上传excel。</p>
      </div>
      <div class="ivu-modal-footer">
        <Button type="primary" ghost @click="visible=false">取消</Button>
        <Button type="primary" @click="download"><i class="iconfont icondaoru1"></i>下载模板</Button>
        <Upload ref="upload" v-if="data.uploadUrl" :show-upload-list="false" class="upload-btn" :max-size="2048" 
        :data="data.uploadParams" :before-upload="handleBeforeUpload" :action="data.uploadUrl">
          <Button type="primary" :loading="loading"><i class="iconfont icondaochu" v-if="!loading"></i>上传excel</Button>
        </Upload>
        
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  components: {},
  props: [],
  data() {
    return {
      columns:[
        {
          title: "行号",
          key: 'row',
          width: 100,
          align: 'center'
        },
        {
          title: "错误原因",
          key: "content",
          align: 'center',
          minWidth: 100,
        }
      ],
      fileFormat:['xls','xlsx', 'XLS', 'XLSX'],
      visible:false,
      loading: false,
      data:{}
    };
  },
  watch: {},
  computed: {},
  mounted() {
  },
  methods: {
    open(data={}){
      this.data = data;
      this.loading = false;
      this.visible = true;
    },
    download(){
      this.$units.downloadFile(this.data.template, this.data.params, "GET", this.data.templateName)
    },
    handleBeforeUpload(file){
      const format = file.name.split("\.")[1];
      if(!this.fileFormat.includes(format)){
        this.$notice.msg("请上传"+this.fileFormat.join(",")+"格式的文件")
        return false;
      }
      let formData = new FormData();
      formData.append("file", file);
      const params = this.data.uploadParams
      if(params){
        for (const key in params) {
          if (Object.hasOwnProperty.call(params, key)) {
            const element = params[key];
            formData.append(key, element);
          }
        }
      }
      this.loading = true;
      this.$http({
        type: "POST",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        url: this.data.uploadUrl,
        data: formData
      }).then(res=>{
        const successNum = res.data.successList&&res.data.successList.length;
        const errorNum = res.data.errorList&&res.data.errorList.length;
        let text = `系统已成功导入${successNum}条数据`;
        if(errorNum){
          text = text+`，存在${errorNum}条数据未导入`;
          if(this.data.errorUrl){
            this.$units.downloadFile(this.data.errorUrl, {
              errorList: res.data.errorList
            },"POST")
          }
          this.$notice.error(text)
        }else{
          this.visible = false;
          this.$notice.success(text)
        }
        this.$emit("success");
      }).finally(() => {
        this.loading = false;
      });
      
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index2.scss";
</style>
